import React from 'react';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Keep the error visible in the console for debugging.
    // eslint-disable-next-line no-console
    console.error('AppErrorBoundary caught an error:', error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-fallback">
          <div className="app-fallback__card">
            <p className="app-fallback__eyebrow">Rendering failed</p>
            <h1>The app hit an unexpected state.</h1>
            <p>Reload the page to recover. Cached data should make the next load smoother.</p>
            <button type="button" className="primary-button" onClick={this.handleReload}>
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
